// Icons Material can be defined here, not fontAwesome

import {
  PicTreeReviewSummaryNttFt,
  PicTreeReviewByAssetTypeNttFt,
  PicTreeCheckInNttFt,
  PicTreeMapNttFt,
  PicTreeReportSummaryNttFt,
  PicTreeMissionSummary,
  PicTreeMissionRanking,
} from "pages";

export default {
  items: [
    {
      path: "/game/pictree/ntt-ft/photos/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "撮影",
      component: PicTreeReviewSummaryNttFt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt-ft/photos/asset-type",
      name: "アセットタイプ別",
      type: "link",
      icon: false,
      component: PicTreeReviewByAssetTypeNttFt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt-ft/photos/map",
      name: "地図表示",
      type: "link",
      icon: false,
      component: PicTreeMapNttFt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt-ft/checkin",
      name: "チェックイン",
      type: "link",
      icon: false,
      component: PicTreeCheckInNttFt,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/ntt-ft/mission",
      name: "ミッションモード",
      type: "submenu",
      sideBar: true,
      children: [
        {
          path: "/overview",
          name: "概要",
          icon: null,
          component: PicTreeMissionSummary,
        },
        {
          path: "/ranking",
          name: "達成ランキング",
          icon: null,
          component: PicTreeMissionRanking,
        },
      ],
    },
    {
      path: "/game/pictree/ntt-ft/report/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "報告",
      component: PicTreeReportSummaryNttFt,
      sideBar: true,
      divider: false,
    },
  ],
};
